<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <Header/>
    <b-container fluid>
      <b-row class="titulo">
        <b-col class="seccionTitulo">
          <span class="fa fa-table"></span>
          <span>Reporte citas</span>
        </b-col>
        <b-col class="seccionCodigo">
          <div>RP_02_CITAS</div>
        </b-col>
      </b-row>

      <b-row>
        <b-col class="subtitulos">
          Generación de reporte de citas
        </b-col>
      </b-row>

      <div class="mt-2 col-md-12"></div>
      <label>Estatus por columna:<br/></label>
      <ul>
        <li>(A) Agendadas (Normal, Confirmadas, Asistidas, No asistidas, Canceladas, Eliminadas)</li>
        <li>(B) Confirmadas (Confirmadas, No asistidas con fecha de confirmación)</li>
        <li>(C) Asistidas (Asistidas)</li>
        <li>(D) Asistidas Confirmadas (Asistidas con fecha de confirmación)</li>
        <li>(E) Canceladas (Canceladas)</li>
        <li>(F) Canceladas Confirmadas (Canceladas con fecha de confirmación)</li>
      </ul>
      <br/>
      <div class="mt-2 col-md-12"></div>

      <validation-observer ref="observer" v-slot="{ handleSubmit }">
        <b-form @submit.stop.prevent="handleSubmit(generar)">

          <b-row>
            <b-col>
              <b-row align-v="center" align-h="end">
                <b-col cols="4">
                  <validation-provider name="fcInicioVal" :rules="{ required: true }" v-slot="validationContext">
                    <label>Fecha de inicio:<validacion/></label>
                    <b-input-group size="sm" class="mb-2">
                      <b-form-datepicker placeholder="Fecha inicio"
                                         v-model="filtro.fechaInicio"
                      ></b-form-datepicker>
                    </b-input-group>
                    <validacion :texto="validationContext.errors[0] ? validationContext.errors[0] : ' '"/>
                  </validation-provider>
                </b-col>

                <b-col cols="4">
                  <validation-provider name="fcFinVal" :rules="{ required: true }" v-slot="validationContext">
                    <label>Fecha de fin:<validacion/></label>
                    <b-input-group size="sm" class="mb-2">
                      <b-form-datepicker placeholder="Fecha fin"
                                         v-model="filtro.fechaFin"
                      ></b-form-datepicker>
                    </b-input-group>
                    <validacion :texto="validationContext.errors[0] ? validationContext.errors[0] : ' '"/>
                  </validation-provider>
                </b-col>

                <b-col align="right">
                  <b-button type="submit" v-b-tooltip.hover title="Generar reporte" variant="outline-success"
                            :disabled="loader">Generar
                  </b-button>
                </b-col>

              </b-row>
            </b-col>
          </b-row>

        </b-form>
      </validation-observer>

      <div class="mt-2 col-md-12"></div>


      <b-row>
        <b-col cols="12">
          <b-table
              thead-tr-class="columnas"
              :items="datosTabla1"
              :fields="fields1"
              :per-page="$registrosPorPaginaTabla"
              :current-page="paginaActual1"
              responsive>
            <template v-slot:cell(clinica)="row">
              <div>Todas</div>
            </template>
            <template v-slot:cell(confirmadasPorcentaje)="row">
              <div>{{row.item.confirmadasPorcentaje | numeroDosDecimales}}%</div>
            </template>
            <template v-slot:cell(asistidasPorcentaje)="row">
              <div>{{row.item.asistidasPorcentaje | numeroDosDecimales}}%</div>
            </template>
            <template v-slot:cell(asistidasConfirmadasPorcentaje)="row">
              <div>{{row.item.asistidasConfirmadasPorcentaje | numeroDosDecimales}}%</div>
            </template>
            <template v-slot:cell(asistidasSinConfirmarPorcentaje)="row">
              <div>{{row.item.asistidasSinConfirmarPorcentaje | numeroDosDecimales}}%</div>
            </template>
            <template v-slot:cell(canceladasPorcentaje)="row">
              <div>{{row.item.canceladasPorcentaje | numeroDosDecimales}}%</div>
            </template>
            <template v-slot:cell(reagendadasPorcentaje)="row">
              <div>{{row.item.reagendadasPorcentaje | numeroDosDecimales}}%</div>
            </template>
          </b-table>
          <div align="center" v-if="loader">
            <b-spinner variant="primary" label="Spinning"></b-spinner>
          </div>
          <b-col v-if="!loader">
            <b-alert v-if="datosTabla1!==undefined && datosTabla1.length === 0" variant="warning" show>No hay datos
            </b-alert>
          </b-col>
          <b-col v-if="!loader">
            <b-pagination
                v-if="datosTabla1 !== undefined && datosTabla1.length > 10"
                align="center"
                v-model="paginaActual1"
                :total-rows="datosTabla1.length"
                :per-page="$registrosPorPaginaTabla"
                aria-controls="tabla1"
            ></b-pagination>
          </b-col>
        </b-col>
      </b-row>

      <div class="mt-2 col-md-12"></div>

      <b-row>
        <b-col cols="12">
          <b-table
              thead-tr-class="columnas"
              :items="datosTabla2"
              :fields="fields1"
              :per-page="100"
              :current-page="paginaActual2"
              responsive>
            <template v-slot:cell(confirmadasPorcentaje)="row">
              <div>{{row.item.confirmadasPorcentaje | numeroDosDecimales}}%</div>
            </template>
            <template v-slot:cell(asistidasPorcentaje)="row">
              <div>{{row.item.asistidasPorcentaje | numeroDosDecimales}}%</div>
            </template>
            <template v-slot:cell(asistidasConfirmadasPorcentaje)="row">
              <div>{{row.item.asistidasConfirmadasPorcentaje | numeroDosDecimales}}%</div>
            </template>
            <template v-slot:cell(asistidasSinConfirmarPorcentaje)="row">
              <div>{{row.item.asistidasSinConfirmarPorcentaje | numeroDosDecimales}}%</div>
            </template>
            <template v-slot:cell(canceladasPorcentaje)="row">
              <div>{{row.item.canceladasPorcentaje | numeroDosDecimales}}%</div>
            </template>
            <template v-slot:cell(reagendadasPorcentaje)="row">
              <div>{{row.item.reagendadasPorcentaje | numeroDosDecimales}}%</div>
            </template>
          </b-table>
          <div align="center" v-if="loader">
            <b-spinner variant="primary" label="Spinning"></b-spinner>
          </div>
          <b-col v-if="!loader">
            <b-alert v-if="datosTabla2!==undefined && datosTabla2.length === 0" variant="warning" show>No hay datos
            </b-alert>
          </b-col>
          <b-col v-if="!loader">
            <b-pagination
                v-if="datosTabla2 !== undefined && datosTabla2.length > 100"
                align="center"
                v-model="paginaActual2"
                :total-rows="datosTabla2.length"
                :per-page="$registrosPorPaginaTabla"
                aria-controls="tabla2"
            ></b-pagination>
          </b-col>
        </b-col>
      </b-row>

    </b-container>
  </div>
</template>

<script>
import Header from "../../components/Header";

export default {
  components: {
    Header
  },
  data: () => {
    return {
      version: process.env.VUE_APP_ENV_VERSION,
      debug: false,

      datosTabla1: [],
      datosTabla2: [],
      fields1: [
        {key: "clinica", label: "Clínica", sortable: true},
        {key: "agendadas", label: "(A) Agendadas", sortable: true},
        {key: "confirmadas", label: "(B) Confirmadas", sortable: true},
        {key: "asistidas", label: "(C) Asistidas", sortable: true},
        {key: "asistidasConfirmadas", label: "(D) Asistidas Confirmadas", sortable: true},
        {key: "canceladas", label: "(E) Canceladas", sortable: true},
        {key: "canceladasConfirmadas", label: "(F) Canceladas Confirmadas", sortable: true},
        {key: "reagendadas", label: "(G) Reagendadas", sortable: true},
        {key: "confirmadasPorcentaje", label: "(B/A) Confirmadas", sortable: true},
        {key: "asistidasPorcentaje", label: "(C/A) Asistidas", sortable: true},
        {key: "asistidasConfirmadasPorcentaje", label: "(D/B) Asistidas Confirmadas", sortable: true},
        {key: "asistidasSinConfirmarPorcentaje", label: "(C-D)/(A-B) Asistidas Sin Confirmación", sortable: true},
        {key: "canceladasPorcentaje", label: "(E/A) Canceladas", sortable: true},
        {key: "reagendadasPorcentaje", label: "(G/A) Reagendadas", sortable: true},
      ],
      paginaActual1: 1,
      paginaActual2: 1,
      loader: false,
      filtro: {
        fechaInicio: null,
        fechaFin: null
      },
    }
  },
  created() {
    this.debug = this.$localStorageService.getDebug();
  },
  methods: {
    generar() {
      this.loader = true;
      this.datosTabla1 = [];
      this.datosTabla2 = [];

      const filtroNuevo = {
        "fechaInicio": this.filtro.fechaInicio !== null ? this.$moment(this.filtro.fechaInicio).format("YYYY-MM-DD") : null,
        "fechaFin": this.filtro.fechaFin !== null ? this.$moment(this.filtro.fechaFin).format("YYYY-MM-DD") : null,
      }

      this.$http.post(this.$api + 'reportes/citas', filtroNuevo).then(respuesta => {
        if (respuesta.data.data) {
          this.datosTabla1 = respuesta.data.data.tabla1;
          this.datosTabla2 = respuesta.data.data.tabla2;
        }
      }).finally(() => {
        this.loader = false;
        this.paginaActual1 = 1;
        this.paginaActual2 = 1;
      })
    }
  }
}
</script>

<style scoped>

</style>
